import whatsapp from './whatsapp';
import telegram from './telegram';
import facebook from './facebook';
import twitter from './twitter';
import pinterest from './pinterest';

export default [whatsapp, facebook, telegram, twitter, pinterest];
